// @ts-check
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import NavBarComponent from './components/navbar-component';

import HomePage from '../../features/home/presentation/pages/home-page';

import ClientsPage from '../../features/clients/presentation/pages/clients-page';
import ClientPage from '../../features/clients/presentation/pages/client-page';
import { CreateClientPage } from '../../features/clients/presentation/pages/create-client-page';

import { UsersPage } from '../../features/users/presentation/pages/users-page';
import { CreateUserPage } from '../../features/users/presentation/pages/create-user-page';
import { AccessComponent } from './components/access-component';

import { ProfilePage } from '../../features/me/presentation/pages/profile-page';
import UserPage from '../../features/users/presentation/pages/user-page';
import AdminPage from '../../features/admin/presentation/pages/admin-page';
import AdminClientPage from '../../features/admin/presentation/pages/admin-client-page';
import TerminateOrdersPage from '../../features/orders/presentation/pages/terminate-orders';

import { CreatePartnerPage } from '../../features/three-pl-partners/presentation/pages/create-partner-page';
import PartnersPage from '../../features/three-pl-partners/presentation/pages/partners-page';
import PartnerPage from '../../features/three-pl-partners/presentation/pages/partner-page';

const Routes = () => {
  return (
    <Router>
      <Switch>
        {/* <Route path="/login" component={LoginPage} /> */}

        <AccessComponent>
          <NavBarComponent>
            <Route exact path="/" component={HomePage} />

            <Route exact path="/clients" component={ClientsPage} />
            <Route path="/clients/create" component={CreateClientPage} />
            <Route path="/clients/:id/view" component={ClientPage} />

            <Route exact path="/users" component={UsersPage} />
            <Route path="/users/:id/view" component={UserPage} />
            <Route path="/users/create" component={CreateUserPage} />

            <Route exact path="/admin" component={AdminPage} />
            <Route exact path="/admin/:id" component={AdminClientPage} />
            <Route exact path="/admin/terminate-orders/:id" component={TerminateOrdersPage} />

            <Route path="/account" component={ProfilePage} />

            <Route exact path="/partners" component={PartnersPage} />
            <Route path="/partners/create" component={CreatePartnerPage} />
            <Route path="/partners/:id/view" component={PartnerPage} />
          </NavBarComponent>
        </AccessComponent>
      </Switch>
    </Router>
  );
};

export default Routes;
